import React, { useEffect, useState } from 'react'
import { RightArrow, SearchIcon, SearchIconWhite } from '../../../../assets/images'
import StorageConfig from '../StorageConfig/StorageConfig';
import { useForm } from 'react-hook-form';
import { addCentralizeRecordingSystem, deleteCentralizeRecordingSystem, GetCentralizeRecordingSystem, getSiteTypeList, updateCentralizeRecordingSystem } from '../../../../services/configurationServices';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import Swal from 'sweetalert2';
import AlertTemplateMessage from '../../AlertTemplate/AlertTemplateMessage';

let recordSystemObj = {
  "ServerName": '',
  "PrimaryAddress": '',
  "SecondaryAddress": ''
}
const RecordingSetting = ({ isDarkTheme, addNewServerClicked, setAddNewServerClicked, isRecordingFormEnabled, setIsRecordingFormEnabled, item }) => {

  const [storageForm, setStorageForm] = useState(false);
  const [serverName, setServerName] = useState('')
  const [serverNameError, setServerNameError] = useState("")
  const [primaryAddress, setPrimaryAddress] = useState("");
  const [primaryAddressError, setPrimaryAddressError] = useState("");
  const [secondaryAddress, setSecondaryAddress] = useState("");
  const [secondaryAddressError, setSecondaryAddressError] = useState("");
  const [isFormEdit, setIsFormEdit] = useState(false)
  const [recordingSearch, setRecordingSearch] = useState("");
  const [recordingList, setRecordingList] = useState(null);
  const [mainRecordingList, setMainRecordingList] = useState([]);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false)
  const [recordingServerType, setRecordingServerType] = useState([])

  const [recordingServerTypeError, setRecordingServerTypeError] = useState("")
  const [selectedRecordingServerType, setSelectedRecordingServerType] = useState("0")
  console.log("selectedRecordingServerType", selectedRecordingServerType)
  useEffect(() => {
    getServerList()
  }, [])

  useEffect(() => {
    handleRecordingTypeServer()
  }, [])

  const handleStorageSetting = () => {
    setStorageForm(true);
  }
  const handleStorageForm = () => {
    setPrimaryAddressError('');
  }

  const clearRecordingForm = () => {
    setServerName('')
    setServerNameError('')
    setPrimaryAddress('')
    setPrimaryAddressError('')
    setSecondaryAddress('')
    setSecondaryAddressError('')
    setIsFormEdit(false)
    setSelectedRecording(null)
    setRecordingServerTypeError('')
    setSelectedRecordingServerType('')
    //setRecordingServerType(null)
  }

  const getServerList = () => {
    GetCentralizeRecordingSystem().then((resp) => {
      if (resp.Status == "success" && resp.Data != null) {
        setRecordingList(resp.Data);
        setMainRecordingList(resp.Data);
      } else {
        setRecordingList(null);
        setMainRecordingList(null)
      }
    }).catch(err => console.log(err))
  }
  const searchRecordingList = (e) => {
    setRecordingSearch(e.target.value);
    let tempArr = mainRecordingList.filter((x) =>
      x.RecordingStorageName.toLowerCase().includes(
        e.target.value.toLowerCase()
      )
    );
    setRecordingList(tempArr);
  };

  const deleteServer = () => {
    setButtonDisable(true);
    try {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to delete server!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#027aaa",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteCentralizeRecordingSystem(selectedRecording?.RecordingStorageID).then((res) => {
            if (res.Status == "success") {
              setButtonDisable(false);
              SuccessToast(res.Message);
              getServerList();
              //   setNotifDeleteBtnClicked(false);
              //   setIsNotifFormEnabled(true);
              clearRecordingForm()
              setSelectedRecording(null)
            }
            else if (res.Status == "failed") {
              Swal.fire({ text: res.Message });
              setButtonDisable(false);
            } else {
              Swal.fire({ text: "Something went wrong, please try again later!" })
              setButtonDisable(false);
            }

          })
            .catch((err) => console.log(err));
        } else {
          setButtonDisable(false);
        }
      });
    } catch (error) {
      console.log(error);
      setButtonDisable(false);
    }
  }

  const onSaveServerName = async () => {
    let isValidate = false

    if (serverName == "") {
      setServerNameError("Please enter server name!")
      isValidate = true;
    }

    if (primaryAddress == "") {
      setPrimaryAddressError("Please enter primary server address")
      isValidate = true
    }
    console.log("")
    if (selectedRecordingServerType == 0 || selectedRecordingServerType == "") {
      setRecordingServerTypeError("Please select video backup  type")
      isValidate = true
    }
    if (isValidate) {
      return;
    }
    let user = JSON.parse(localStorage.getItem("user"));
    if (selectedRecording == null) {
      let addServerObj = {
        OrganizationMasterID: user?.OrganizationMasterID.toString(),
        RecordingStorageName: serverName,
        PrimaryServerAdd: primaryAddress,
        RecordingServerTypeID: selectedRecordingServerType.toString()
      }
      addCentralizeRecordingSystem(addServerObj).then((resp) => {
        if (resp.Status == "success") {
          getServerList()
          SuccessToast(resp.Message)
          clearRecordingForm()
          setSelectedRecording(null)

        } else {
          ErrorToast(resp.Message);
        }
      });
    } else {
      let updateServerObj = {
        OrganizationMasterID: user?.OrganizationMasterID.toString(),
        RecordingStorageName: serverName,
        PrimaryServerAdd: primaryAddress,
        RecordingStorageID: selectedRecording.RecordingStorageID?.toString(),
        RecordingServerTypeID: selectedRecordingServerType.toString()
      }
      updateCentralizeRecordingSystem(updateServerObj).then((resp) => {
        if (resp.Status == "success") {
          getServerList()
          setIsFormEdit(false)
          clearRecordingForm();
          SuccessToast(resp.Message);
          setSelectedRecording(null)
        } else {
          ErrorToast(resp.Message)
        }
      })
    }
  }
  const handleRecordingTypeServer = () => {

    try {
      let obj = {
        type: "RecordingServerType",

      };
      getSiteTypeList(obj).then((resp) => {
        if (resp != undefined) {
          if (resp.Status == "success") {
            setRecordingServerType(resp.Data)
          } else {
            setRecordingServerType([])
          }
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  const onNumberOnlyChange2 = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp("[0-9.]").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };
  console.log("item206", item)
  console.log("selectedRecording", selectedRecording)
  return (
    <div className='col-lg-12 mt-2'>
      {storageForm ? (
        <StorageConfig isDarkTheme={isDarkTheme} setStorageForm={setStorageForm} storageForm={storageForm} item={selectedRecording} resetServer={clearRecordingForm} recordingServerType={recordingServerType} selectedRecordingServerType={selectedRecordingServerType} />
      ) : (
        <div className='SiteMainContainer UserHgtContainer'>


          <div className="SiteMainHeightDiv">
            <div className='SiteLeftContainer AutoHgtSiteScrollbar'>
              <div className="m-2 HeaderSiteList">
                <input
                  id="Search_txt_site"
                  className="SearchViewInput1"
                  type="text"
                  placeholder="Search Recording System"
                  value={recordingSearch}
                  onChange={(e) => searchRecordingList(e)}
                />
                <div className="SearchTextDivConfigTool">
                  {
                    isDarkTheme ?
                      <img
                        className="EyeIcon"
                        src={SearchIcon}
                        alt="search icon"
                      /> :
                      <img
                        className="EyeIcon"
                        src={SearchIconWhite}
                        alt="search icon" height="15"
                      />
                  }
                </div>
              </div>
              <div className="StepperSiteList" id="siteListDiv" >
                {
                  recordingList && (
                    recordingList.length > 0
                      ?
                      recordingList?.map((item) => (
                        <div key={item?.RecordingStorageID}
                          className={selectedRecording?.RecordingStorageID == item?.RecordingStorageID ? `OneList SelectedList p-0 pr-1` : `OneList p-0 pr-1`}
                        >
                          <div className="ListSiteWithZone"
                            onClick={(e) => {
                              console.log("item251", item)
                              setPrimaryAddress(item?.PrimaryServerAdd)
                              setServerName(item?.RecordingStorageName)
                              setSelectedRecording(item)
                              setIsFormEdit(true)
                              handleStorageForm()
                              setSelectedRecordingServerType(item?.RecordingServerTypeID)

                            }}
                          >
                            <p className="ListofText">
                              {item?.RecordingStorageName}
                            </p>
                          </div>
                          <button className="addCustomer" style={{ marginLeft: "10px" }}
                            onClick={() => {
                              handleStorageSetting()
                              setSelectedRecording(item)
                              setPrimaryAddress(item?.PrimaryServerAdd)
                              setServerName(item?.RecordingStorageName)
                              setSelectedRecordingServerType(item?.RecordingServerTypeID)
                            }}
                          >
                            <span className="ViewUpdate">
                              <img src={RightArrow} alt="add plus icon" />
                            </span>
                          </button>
                        </div>
                      ))
                      :
                      <div className="no-data-found"><p>No Recording Found</p></div>
                  )
                }
                {
                  !recordingList && (
                    <div className="no-data-found">No Recording Available</div>
                  )
                }
              </div>
            </div>

            <div className='SiteRightContainer UserMainFormDiv'>
              {
                !selectedRecording?.RecordingStorageID
                &&
                <div style={{ width: "100%", padding: "0rem 1rem", marginTop: "1rem" }}>
                  <AlertTemplateMessage
                    message={
                      "You are allowed to create only one server."
                    }
                  />
                </div>

              }
              {
                (!recordingList || selectedRecording?.RecordingStorageID)
                &&
                <>
                  <div className="userformContainer">
                    <form>
                      <div className='user-form' style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div className="inputMainContainer w40dot75rem mt35">
                          <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Server Name</label>
                            <input
                              className="inputType"
                              placeholder="Enter Recording server name here*"
                              value={serverName}
                              disabled={isFormEdit}
                              onChange={(e) => {
                                setServerName(e.target.value)
                                setServerNameError("")
                              }}
                            />
                            <p className="Error_P" style={{ float: "left" }}><span>{serverNameError}</span></p>
                          </div>
                        </div>
                        <div className="inputMainContainer w40dot75rem mt35">
                          <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Server Address</label>
                            <input
                              className="inputType"
                              placeholder="Server Address* e.g. 192.168.0.54"
                              value={primaryAddress}
                              disabled={isFormEdit}
                              onKeyPress={(e) => {
                                onNumberOnlyChange2(e);
                                setPrimaryAddressError('')
                              }}
                              onChange={(e) => {
                                setPrimaryAddress(e.target.value)
                                setPrimaryAddressError("")
                              }}
                            />
                            <p className="Error_P" style={{ float: "left" }}><span>{primaryAddressError}</span></p>
                          </div>
                        </div>
                        <div className="inputMainContainer w40dot75rem mt35">
                          <div className="inputTypeLabelContainer">
                            <label className='formFieldLabels'>Video Backup Type</label>
                            <select
                              //   {...register("CountryName")}
                              value={selectedRecordingServerType}
                              //disabled={true}
                              //disabled={selectedRecording?.RecordingStorageID != 0 ?  : false} 
                              disabled={selectedRecording?.RecordingStorageID}
                              className="inputType ArrowSelectClass"
                              onChange={(e) => {
                                setSelectedRecordingServerType(e.target.value)
                                setRecordingServerTypeError('')
                              }}
                            >
                              <option key="0" disabled={false} value="0" id="0">Select Video Backup Type*</option>
                              {recordingServerType &&
                                recordingServerType.map((val) => (
                                  <option value={val.RecordingServerTypeID} key={val.RecordingServerTypeID} id={val.RecordingServerTypeID}>
                                    {val.RecordingServerType}
                                  </option>
                                ))}
                            </select>
                            <p className="Error_P" style={{ float: "left" }}><span> {recordingServerTypeError} </span></p>
                          </div>
                        </div>
                        {/* <div className="inputMainContainer w40dot75rem mt35">
                                    <div className="inputTypeLabelContainer">
                                        <label className='formFieldLabels'>Secondary Server Address</label>
                                        <input
                                            className="inputType"
                                            placeholder="Secondary Address* e.g. 192.168.0.54"
                                            value={secondaryAddress}
                                            disabled={isFormEdit}
                                            onChange={(e) => {
                                            setSecondaryAddress(e.target.value)
                                            setSecondaryAddressError("")
                                            }}
                                        />
                                        <p className="Error_P" style={{ float: "left" }}><span>{secondaryAddressError}</span></p>
                                    </div>
                                </div> */}
                      </div>
                    </form>
                  </div>
                  <div style={{ textAlign: "center", marginBottom: "10px" }}>
                    {/* {
                        isFormEdit
                            &&
                        <button className="DataAccessEdit" style={{ width: "100px" }} onClick={clearRecordingForm}>
                        <span className="ViewUpdate">Add New</span>
                        </button>
                            } */}
                    {
                      isFormEdit && !!selectedRecording?.RecordingStorageID
                      &&
                      <button className="DataAccessEdit" style={{ width: "100px" }} onClick={() => setIsFormEdit(false)}>
                        <span className="ViewUpdate">Edit</span>
                      </button>
                    }
                    {
                      (!isFormEdit && selectedRecording?.RecordingStorageID)
                      &&
                      <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSaveServerName}>
                        <span className="ViewUpdate">Save</span>
                      </button>
                    }
                    {
                      //isFormEdit - False
                      (!isFormEdit && !recordingList)
                      &&
                      <button className="DataAccessEdit" style={{ width: "100px" }} onClick={onSaveServerName}>
                        <span className="ViewUpdate">Save</span>
                      </button>
                    }
                    {
                      isFormEdit && !!selectedRecording?.RecordingStorageID
                      &&
                      <button className="DataAccessEdit" style={{ width: "100px" }}
                        onClick={deleteServer}
                      >
                        <span className="ViewUpdate">Delete</span>
                      </button>
                    }

                  </div>
                </>

              }


            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default RecordingSetting